import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import mileageContractListingUserPermissionDefinition from "./mileage-contract-listing-user-permission";

const useMileageContractListingUserPermissions = () => {
  return useUserPermissions(mileageContractListingUserPermissionDefinition);
};

export default useMileageContractListingUserPermissions;
